(() => {
  const clampQuantity = (input, nextValue) => {
    const min = Number.parseInt(input.min || '0', 10);
    const max = input.max === '' ? Number.POSITIVE_INFINITY : Number.parseInt(input.max, 10);
    const safeValue = Number.isFinite(nextValue) ? nextValue : min;
    input.value = String(Math.min(max, Math.max(min, safeValue)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!(button instanceof HTMLButtonElement)) return;
    const control = button.closest('[data-quantity-control]');
    const input = control?.querySelector('[data-quantity-input]');
    if (!(input instanceof HTMLInputElement)) return;
    const direction = button.hasAttribute('data-quantity-plus') ? 1 : -1;
    clampQuantity(input, Number.parseInt(input.value || '0', 10) + direction);
  });

  document.addEventListener('focusout', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-quantity-input]')) return;
    clampQuantity(input, Number.parseInt(input.value || '0', 10));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-form]')) return;
    if (form.dataset.cartNativeSubmit === 'true') {
      delete form.dataset.cartNativeSubmit;
      return;
    }
    if (form.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }

    const submitter = event.submitter;
    const intent = submitter instanceof HTMLButtonElement ? submitter.name : 'update';
    if (!['update', 'checkout'].includes(intent) || typeof window.fetch !== 'function') return;

    event.preventDefault();
    if (!form.reportValidity()) return;

    const errors = form.querySelector('[data-cart-errors]');
    const errorText = form.querySelector('[data-cart-error-text]');
    const reloadLink = form.querySelector('[data-cart-reload]');
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    const changes = [];
    form.querySelectorAll('[data-cart-line]').forEach((line) => {
      const key = line.getAttribute('data-cart-key');
      const input = line.querySelector('[data-quantity-input]');
      if (key && input instanceof HTMLInputElement) {
        changes.push({ key, quantity: Number.parseInt(input.value || '0', 10) });
      }
    });

    if (errors instanceof HTMLElement) {
      errors.hidden = true;
      if (errorText instanceof HTMLElement) errorText.textContent = '';
      if (reloadLink instanceof HTMLElement) reloadLink.hidden = true;
    }
    form.setAttribute('aria-busy', 'true');
    buttons.forEach((button) => { button.disabled = true; });

    let serverChanged = false;
    try {
      const fallbackRoot = window.Shopify?.routes?.root || '/';
      const changeUrl = form.dataset.cartChangeUrl || `${fallbackRoot}cart/change.js`;

      for (const change of changes) {
        let response;
        try {
          response = await fetch(changeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: change.key, quantity: change.quantity })
          });
        } catch (networkError) {
          const requestError = networkError instanceof Error ? networkError : new Error(form.dataset.cartErrorMessage);
          requestError.cartStateUnknown = true;
          throw requestError;
        }

        let payload;
        try {
          payload = await response.json();
        } catch (_jsonError) {
          const responseError = new Error(form.dataset.cartErrorMessage);
          responseError.cartStateUnknown = true;
          throw responseError;
        }
        if (!response.ok) {
          const requestError = new Error(payload.description || payload.message || form.dataset.cartErrorMessage);
          requestError.cartPartiallyChanged = serverChanged;
          throw requestError;
        }

        serverChanged = true;
        if (!Array.isArray(payload.items)) {
          const responseError = new Error(form.dataset.cartErrorMessage);
          responseError.cartStateUnknown = true;
          throw responseError;
        }
        const updatedLine = payload.items.find((item) => item.key === change.key);
        const quantityAccepted = change.quantity === 0 ? !updatedLine : updatedLine?.quantity === change.quantity;
        if (!quantityAccepted) {
          const adjustedError = new Error(form.dataset.cartAdjustedMessage || form.dataset.cartErrorMessage);
          adjustedError.cartPartiallyChanged = true;
          throw adjustedError;
        }
      }

      if (intent === 'checkout') {
        form.querySelectorAll('[name="updates[]"]').forEach((input) => input.removeAttribute('name'));
        form.dataset.cartNativeSubmit = 'true';
        form.removeAttribute('aria-busy');
        buttons.forEach((button) => { button.disabled = false; });
        if (typeof form.requestSubmit === 'function' && submitter instanceof HTMLElement) {
          form.requestSubmit(submitter);
        } else {
          const checkoutIntent = document.createElement('input');
          checkoutIntent.type = 'hidden';
          checkoutIntent.name = 'checkout';
          checkoutIntent.value = 'checkout';
          form.append(checkoutIntent);
          HTMLFormElement.prototype.submit.call(form);
        }
        return;
      }

      window.location.reload();
    } catch (error) {
      if (errors instanceof HTMLElement) {
        const baseMessage = error instanceof Error && error.message ? error.message : form.dataset.cartErrorMessage;
        const cartMayHaveChanged = Boolean(error?.cartPartiallyChanged || error?.cartStateUnknown || serverChanged);
        const partialMessage = cartMayHaveChanged ? ` ${form.dataset.cartPartialMessage || ''}` : '';
        if (errorText instanceof HTMLElement) errorText.textContent = `${baseMessage}${partialMessage}`.trim();
        if (reloadLink instanceof HTMLElement) reloadLink.hidden = !cartMayHaveChanged;
        errors.hidden = false;
        errors.focus({ preventScroll: true });
        errors.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    } finally {
      form.removeAttribute('aria-busy');
      buttons.forEach((button) => { button.disabled = false; });
    }
  });

  const openFaqTarget = () => {
    if (!window.location.hash.startsWith('#faq-')) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (!(target instanceof HTMLDetailsElement)) return;
    target.open = true;
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  openFaqTarget();
  window.addEventListener('hashchange', openFaqTarget);

  const status = document.querySelector('.bn-form-status[autofocus]');
  if (status instanceof HTMLElement) status.focus();
})();
